import $ from 'jquery';
import {each, includes, keys, property, values} from 'lodash';
import {View} from 'backbone';
import Handlebars from 'handlebars';
import React from 'react';
import ReactDOM from 'react-dom';

import teaserListTemplate from 'templates/properties/teaserListTemplate.hbs';
import editTeaserTemplate from 'templates/properties/editTeaserTemplate.hbs';
import propertySectionPreviewTemplate from 'templates/properties/propertySectionPreviewTemplate.hbs';
import {beforeMainLoader, completeMainLoader, withMainLoader} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import {clearFileInput} from '@sinclair-digital/stl-common/src/sinclair/sinclair.utils';
import Modal from './MismatchesModal';
import SiteTreeModel from 'models/properties/siteTreeModel';
import ManualTeaserPlacementModel from 'models/properties/manualTeaserPlacementModel';
import ImageCollection from '@sinclair-digital/stl-common/src/collections/media/imageCollection';
import ImageModel from '@sinclair-digital/stl-common/src/models/media/imageModel';
import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';
import {
    addTeaserOpened,
    addTeaserSave,
    changeTeaserPlacement,
    editTeaserPlacement,
    saveTeaserPlacement,
    conflictedTeaserPlacement,
} from 'analytics/teaserPlacement';
import {getPreviewHostOrigin} from '@sinclair-digital/stl-common/src/views/viewUtils';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';

const selectors = {
    responsiveToggles: '.sda-btn-responsive-toggle',
    iframe: '#js-sda-Preview-frame',
};

const teaserBelowFoldClass = 'sda-teaser-below-fold';
const renumberList = (context, $teaserList, teaserCollection) => {
    const visibleCount = $teaserList.data().visibleCount;
    $teaserList.children().each((i, el) =>
        context
            .$(el)
            .toggleClass(teaserBelowFoldClass, i >= visibleCount)
            .find('.sda-teaser-number')
            .text(i + 1),
    );

    each(teaserCollection.models, model =>
        model.set('position', parseInt($teaserList.find(`[data-cid="${model.cid}"] .sda-teaser-number`).text(), 10)),
    );
    teaserCollection.sort();
    return teaserCollection;
};

export default View.extend({
    el: '#admin-main',
    navId: 'admin-properties-tab',
    sdaPageTitle: 'section preview',
    hideHeader: true,
    model: null,
    teaserListCollection: null,
    template: propertySectionPreviewTemplate,
    uploadedImageCollection: new ImageCollection(),
    activeXhr: null,
    events: {
        'click #js-sda-Preview-back': '_backBtnHandler',
        'click #sda-teaser-save': '_saveBtnHandler',
        [`click ${selectors.responsiveToggles}`]: '_resizeContentHandler',
        'click #sda-teaser-panel-hide': '_togglePreviewRightPanel',
        'click #sda-edit-teaser-list': '_togglePreviewRightPanel',
        'mousedown .sda-teaser-draggable': '_selectTeaser',
        'keyup .sda-edit-teaser-headline>[contenteditable="true"]': '_teaserHeadlineEditLimter',
    },
    initialize(opts = {}) {
        bindAllMethods(this);
        this._registerHandlebarsHelper();
        this.siteId = opts.id;
        this.sectionId = opts.sectionId;
        this.model = new SiteTreeModel({siteUuid: opts.id});
        this.manualTeaserPlacementModel = new ManualTeaserPlacementModel({uuid: this.sectionId});
        this.model.fetch(withMainLoader).then(() => {
            this.render();
            this.manualTeaserPlacementModel.fetch().then(this.renderManualTeaserPlacement);
        });
    },
    render() {
        const parentSiteUrl = this.model.get('parentSite').url;
        let sectionPath = null;

        this.templateData = this.model.toJSON();
        sectionPath = this._getSectionPath(this.model.toJSON(), this.sectionId);
        // if sectionPath is equal to /news present the homepage instead
        sectionPath = sectionPath === '/news' ? '/' : sectionPath;

        this.$el.html(this.template(this.templateData)).sdaInitWidgets();

        const domainUrl = getPreviewHostOrigin() + '/renderer/' + parentSiteUrl.replace(/.\w+$/, '');
        const sectionUrl = domainUrl + sectionPath;

        this.$(selectors.iframe).attr('src', `${sectionUrl}?LatestContent&_=${Date.now().toString()}`);
        this.$('#sda-preview-section-target').text(parentSiteUrl + sectionPath);

        return this;
    },
    // recursive search on sections to return section path
    _getSectionPath(obj, uuid) {
        const childrenLen = obj.children.length;

        if (obj.uuid === uuid) {
            // If this is the section, return the pathUrl
            this.templateData.sectionStatus = obj.status;

            return obj.pathUrl;
        } else if (childrenLen) {
            // recurse through each child.
            for (let i = 0; i < childrenLen; i += 1) {
                const result = this._getSectionPath.call(this, obj.children[i], uuid);

                // if descendant is section, prepend this sections pathUrl
                if (result) {
                    // if obj is root path do not prepend
                    if (obj.pathUrl === '/') {
                        return result;
                        // else prepend this sections path to the descendents path
                    } else {
                        return obj.pathUrl + result;
                    }
                }
            }
        }
        // section was not found
        return false;
    },

    recordEdit(edit) {
        this.manualTeaserPlacementModel.edits.push(edit);
    },

    renderManualTeaserPlacement() {
        const teaserListCollection = this.manualTeaserPlacementModel.get('teaserLists');
        const teaserListsHtml = teaserListCollection.models
            .map(teaserList => teaserListTemplate(teaserList.toJSONWithCids()))
            .join('');
        this.teaserListCollection = teaserListCollection;

        this.$('#sda-teaser-lists').html(teaserListsHtml);

        each($('.sda-teaser-draggable'), item => {
            const $item = $(item);

            $item.data({
                originalPosition: {
                    list: $item
                        .closest('.sda-teaser-list')
                        .attr('id')
                        .replace('id-', ''),
                    position: parseInt($item.children('.sda-teaser-number').text(), 10),
                },
            });
        });

        this._registerUIComponents();
    },

    _backBtnHandler() {
        this.routeChanger('property/' + this.siteId);
    },
    _resizeContentHandler(e) {
        const $caller = $(e.target);
        const option = $caller.data('option');

        // not working with jquery data method
        $(selectors.iframe).attr('data-option', option);

        this.$(selectors.responsiveToggles).removeClass('sda-btn-active');
        $caller.addClass('sda-btn-active');
    },
    _togglePreviewRightPanel() {
        const panel = this.$('#sda-right-panel-preview');
        panel.toggleClass('panel-open');

        if (panel.hasClass('panel-open')) {
            editTeaserPlacement({
                label: this.sectionId,
            });
        }
    },
    _teaserHeadlineEditLimter(e) {
        const $target = $(e.target);
        const limit = 140;
        const whitelistKeys = {
            backspace: 8,
            tab: 9,
            enter: 13,
            capslock: 20,
            escape: 27,
            end: 35,
            home: 36,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            delete: 46,
        };

        if ($target.text().length >= limit && !includes(values(whitelistKeys), e.which)) {
            e.preventDefault();
        }
    },
    _teaserHeadlinePasteHandler(elem, e) {
        const savedcontent = elem.innerHTML;
        const processpaste = function(_elem, _savedcontent) {
            const pasteddata = _elem.innerHTML;

            _elem.innerHTML = _savedcontent;
            $(_elem).text(pasteddata.substr(0, 10));
        };
        const waitforpastedata = function(_elem, _savedcontent) {
            const obj = {};

            if (_elem.childNodes && _elem.childNodes.length > 0) {
                processpaste(_elem, _savedcontent);
            } else {
                obj.e = _elem;
                obj.s = _savedcontent;
                obj.callself = function() {
                    waitforpastedata(obj.e, obj.s);
                };

                setTimeout(obj.callself, 20);
            }
        };

        // Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
        if (e && e.clipboardData && e.clipboardData.getData) {
            if (/text\/html/.test(e.clipboardData.types)) {
                elem.innerHTML = e.clipboardData.getData('text/html');
            } else if (/text\/plain/.test(e.clipboardData.types)) {
                elem.innerHTML = e.clipboardData.getData('text/plain');
            } else {
                elem.innerHTML = '';
            }

            waitforpastedata(elem, savedcontent);

            if (e.preventDefault) {
                e.stopPropagation();
                e.preventDefault();
            }

            return false;
        } else {
            // Everything else - empty editdiv and allow browser to paste content into it, then cleanup
            elem.innerHTML = '';
            waitforpastedata(elem, savedcontent);

            return true;
        }
    },
    _initTeaserEditAndAddUI() {
        this._initEditTeaserButtons();
        this._initAddTeaserButtons();
        this._initTeaserImageUploadWidgets();

        this.$('.sda-edit-teaser-headline>[contenteditable="true"]').on('onpaste', this._teaserHeadlinePasteHandler);
        this.$('.sda-edit-teaser-headline>[contenteditable="true"]').on('keydown', this._teaserHeadlineEditLimter);
        this.$('.sda-edit-teaser-headline>[contenteditable="true"]').on('keyup', e => {
            const $caller = this.$(e.target);
            const text = $caller.text();
            const limit = 140;

            if (text.length > limit) {
                $caller.text(text.substr(0, limit));
            }
        });
    },

    _initEditTeaserButtons() {
        const that = this;

        each($('.sda-teaser-draggable'), function(teaser) {
            const $teaser = $(teaser);

            $teaser.find('.sda-teaser-edit').sdaModal({
                savetext: 'done',
                canceltext: 'back',
                toggle: 'sda-confirm',
                template: editTeaserTemplate,
                onSave() {
                    const $teaserUi = $(this).closest('.sda-edit-teaser-modal-wrapper');
                    const teaserListUuid = $teaser.closest('.sda-teaser-list-wrapper').data('teaser-list-uuid');
                    const teaserList = that.teaserListCollection.findWhere({uuid: teaserListUuid}).get('teasers');
                    const teaserUpdates = {
                        modifiedData: true,
                        title: $teaserUi
                            .find('.sda-edit-teaser-headline div[contenteditable="true"]')
                            .text()
                            .trim(),
                        summary: $teaserUi
                            .find('.sda-edit-teaser-summary textarea')
                            .val()
                            .trim(),
                        url: $teaserUi.find('.sda-edit-teaser-link-input').val(),
                    };
                    // If an image was uploaded...
                    if ($teaserUi.find('.sda-teaser-img').data('imageUploaded')) {
                        // Get the list of default renditions from the image collection
                        keys(that.uploadedImageCollection.getRenditions()).forEach(function(rendition) {
                            // and apply each rendition to the teaser
                            teaserUpdates[rendition] = that.uploadedImageCollection.at(0).get('image')[rendition];
                        });
                    }

                    const teaserModel = teaserList.get({cid: $teaser.data('cid')});
                    teaserModel.set(teaserUpdates);
                    that.manualTeaserPlacementModel.edits.push({
                        type: 'edit',
                        uuid: teaserModel.get('uuid') || teaserModel.cid,
                        attrs: teaserUpdates,
                    });

                    that.renderManualTeaserPlacement();
                },
                onCancel() {
                    const $teaserUi = $(this).closest('.sda-edit-teaser-modal-wrapper');
                    const $data = $teaserUi.data();
                    $teaserUi.find('.sda-edit-teaser-headline div[contenteditable="true"]').text($data.originalTitle);
                    $teaserUi.find('.sda-edit-teaser-summary textarea').val($data.originalSummary);
                    $teaserUi.find('.sda-edit-teaser-link-input').val($data.originalUrl);
                    $teaserUi.find('.sda-teaser-img').css({backgroundImage: 'url(' + $data.originalImg + ')'});
                },
            });
        });
    },
    _initAddTeaserButtons() {
        const that = this;

        each($('.sda-add-teaser-link'), function(link) {
            $(link).sdaModal({
                savetext: 'done',
                canceltext: 'back',
                toggle: 'sda-confirm',
                template: editTeaserTemplate,
                onShow() {
                    addTeaserOpened({
                        label: $(link)
                            .closest('.sda-teaser-list-wrapper')
                            .data('teaser-list-uuid'),
                    });
                },
                onSave() {
                    const $teaserUi = $(this).closest('.sda-edit-teaser-modal-wrapper');
                    const listUuid = $(link)
                        .closest('.sda-teaser-list-wrapper')
                        .data('teaser-list-uuid');
                    const teaserList = that.teaserListCollection.findWhere({uuid: listUuid}).get('teasers');
                    const teaser = {
                        newTeaser: true,
                        title: $teaserUi
                            .find('.sda-edit-teaser-headline div[contenteditable="true"]')
                            .text()
                            .trim(),
                        summary: $teaserUi
                            .find('.sda-edit-teaser-summary textarea')
                            .val()
                            .trim(),
                        url: $teaserUi.find('.sda-edit-teaser-link-input').val(),
                        validTeaserLists: [listUuid],
                        teaserListUuid: listUuid,
                        modifiedPosition: true,
                        position: 1,
                    };

                    // If an image was uploaded...
                    if ($teaserUi.find('.sda-teaser-img').data('imageUploaded')) {
                        // Get the list of default renditions from the image collection
                        keys(that.uploadedImageCollection.getRenditions()).forEach(function(rendition) {
                            // and apply each rendition to the teaser
                            teaser[rendition] = that.uploadedImageModel.attributes.image[rendition];
                        });
                    }

                    // debug statements
                    if (that.debug) {
                        console.log('Adding teaser: %o', teaser);
                    }

                    // Then add the teaser to the teaser list
                    teaserList.createTeaser(teaser);
                    teaserList.sort();

                    that.manualTeaserPlacementModel.edits.push({
                        type: 'add',
                        listUuid,
                        uuid: teaserList.at(0).cid,
                        attrs: teaser,
                    });

                    // Render it
                    // TODO: This is super expensive right now because we are re-rendering the whole manual teaser
                    // placement flyover
                    that.renderManualTeaserPlacement();

                    addTeaserSave({
                        label: $(link)
                            .closest('.sda-teaser-list-wrapper')
                            .data('teaser-list-uuid'),
                    });
                },
                onCancel() {
                    const $teaserUi = $(this).closest('.sda-edit-teaser-modal-wrapper');
                    const $data = $teaserUi.data();
                    $teaserUi.find('.sda-edit-teaser-headline div[contenteditable="true"]').text($data.originalTitle);
                    $teaserUi.find('.sda-edit-teaser-summary textarea').val($data.originalSummary);
                    $teaserUi.find('.sda-edit-teaser-link-input').val($data.originalUrl);
                    $teaserUi.find('.sda-teaser-img').css({backgroundImage: 'url(' + $data.originalImg + ')'});
                },
            });
        });
    },
    _initTeaserImageUploadWidgets() {
        const that = this;
        const setImageLoadingIndicator = ($modal, isLoading) => {
            const $saveBtn = $modal.find('.sda-modal-save');
            const $teaserImgLoader = $modal.find('.sda-teaser-img-loader');

            if (isLoading) {
                $saveBtn.attr('disabled', 'disabled');
                $teaserImgLoader.css({display: 'flex'}).html(`<sinclair-spinner></sinclair-spinner>`);
            } else {
                $saveBtn.removeAttr('disabled');
                $teaserImgLoader.hide().empty();
            }
        };

        each($('.sda-add-media-wrapper'), function(uploadWidget) {
            const $uploadWidget = $(uploadWidget);
            let $modal;

            $uploadWidget.sdaUpload({
                renditions: null,
                beforeSend: (__, el, xhr) => {
                    const input = $(el)
                        .find('input')
                        .get(0);
                    $modal = $uploadWidget.closest('.sda-edit-teaser-modal-wrapper');
                    setImageLoadingIndicator($modal, true);

                    if (Array.from(input.files).some(file => !file.type.includes('image'))) {
                        messageHandler('error', 'Only images are allowed for teaser media');
                        clearFileInput(input);
                        xhr.abort();
                        setImageLoadingIndicator($modal, false);
                    }
                },
                success(data, el) {
                    that.uploadedImageModel = new ImageModel();
                    data.data[0].images.forEach(function(image) {
                        that.uploadedImageModel.attributes.image[image.name] = image.url;
                    });
                    that.uploadedImageCollection.reset(that.uploadedImageModel);
                    if (that.debug) {
                        console.log('Uploaded Image Collection: %o', that.uploadedImageCollection);
                    }

                    $(el)
                        .prev('.sda-teaser-img')
                        .css('background-image', 'url(' + data.data[0].images[0].url + ')')
                        .data('imageUploaded', true);

                    setImageLoadingIndicator($modal, false);
                },
                error(response) {
                    console.error('Error: %o', response);
                    messageHandler('error', 'Error uploading image');
                    setImageLoadingIndicator($modal, false);
                },
            });
        });
    },
    _registerUIComponents() {
        const that = this;
        const prevClass = 'sda-teaser-before-placeholder';
        const nextClass = 'sda-teaser-after-placeholder';
        const placeHolderFirstClass = 'sda-teaser-placeholder-first';
        const placeHolderLastClass = 'sda-teaser-placeholder-last';

        this._initTeaserEditAndAddUI();

        $('.sda-teaser-list').sortable({
            revert: 0,
            connectWith: '.sda-teaser-list',
            tolerance: 'pointer',
            items: '.sda-teaser-draggable',
            placeholder: 'sda-teaser-placeholder',
            start(e, ui) {
                const $item = that.$(ui.item);
                const $ph = that.$(ui.placeholder);
                let $prev = $ph.prev();
                let $next = $ph.next();

                if ($prev.is($item)) {
                    $prev = $prev.prev();
                } else if ($next.is($item)) {
                    $next = $next.next();
                }

                if (!$prev.length) {
                    $ph.addClass(placeHolderFirstClass);
                    $next.addClass(nextClass);
                } else if (!$next.length) {
                    $ph.addClass(placeHolderLastClass);
                    $prev.addClass(prevClass);
                } else {
                    $ph.removeClass(placeHolderFirstClass + ' ' + placeHolderLastClass);
                    $prev.addClass(prevClass);
                    $next.addClass(nextClass);
                }
                $item.addClass('sda-teaser-selected');
            },
            change(e, ui) {
                const $item = $(ui.item);
                const $ph = $(ui.placeholder);
                const validLists = $item
                    .data()
                    .validLists.trim()
                    .split(' ');
                const selectedListId = $ph.closest('.sda-teaser-list').attr('id');
                let $prev = $ph.prev();
                let $next = $ph.next();

                that.$('.' + prevClass + ', .' + nextClass).removeClass(prevClass + ' ' + nextClass);

                if ($prev.is($item)) {
                    $prev = $prev.prev();
                } else if ($next.is($item)) {
                    $next = $next.next();
                }

                if (!$prev.length) {
                    $ph.addClass(placeHolderFirstClass);
                    $next.addClass(nextClass);
                } else if (!$next.length) {
                    $ph.addClass(placeHolderLastClass);
                    $prev.addClass(prevClass);
                } else {
                    $ph.removeClass(placeHolderFirstClass + ' ' + placeHolderLastClass);
                    $prev.addClass(prevClass);
                    $next.addClass(nextClass);
                }

                if (validLists.includes(selectedListId)) {
                    $ph.removeClass('sda-teaser-error');
                } else {
                    $ph.addClass('sda-teaser-error');
                }
            },
            update(e, ui) {
                // this prevents code from firing twice when sorting from connected lists
                const parent = ui.item.parent()[0];
                if (this !== parent) {
                    return;
                }
                // The teaser
                const $item = $(ui.item);

                // The destination of the teaser
                const $targetList = $(parent);

                // The source of the teaser
                const $sendingList = $(ui.sender || e.target);

                const validLists = $item
                    .data()
                    .validLists.trim()
                    .split(' ');
                const sendingListUuid = $sendingList.attr('id').replace('id-', '');

                // if not a valid list cancel the sort
                if (!sendingListUuid || !validLists.includes($targetList.attr('id'))) {
                    $sendingList.sortable('cancel');
                    return;
                }

                const teaserListCollection = that.teaserListCollection;
                const listUuid = $targetList.attr('id').replace('id-', '');
                const activeTeaserCollection = teaserListCollection.findWhere({uuid: listUuid}).get('teasers');

                const cid = $item.data('cid');
                let teaserModel = activeTeaserCollection.get({cid});

                // item originated from a different list than it is being dropped into
                if (sendingListUuid !== listUuid) {
                    const sendingTeaserCollection = teaserListCollection
                        .findWhere({
                            uuid: sendingListUuid,
                        })
                        .get('teasers');

                    teaserModel = sendingTeaserCollection.get({cid}) || teaserModel;

                    sendingTeaserCollection.remove(teaserModel);
                    activeTeaserCollection.add(teaserModel);

                    renumberList(that, $sendingList, sendingTeaserCollection);
                }

                renumberList(that, $targetList, activeTeaserCollection);

                teaserModel.set('modifiedPosition', true);
                $item.addClass('sda-teaser-updated');

                const indexInCollection = activeTeaserCollection.indexOf(teaserModel);
                const prevTeaser = indexInCollection >= 1 ? activeTeaserCollection.at(indexInCollection - 1) : null;

                that.manualTeaserPlacementModel.edits.push({
                    type: 'move',
                    sendingListUuid,
                    listUuid,
                    uuid: teaserModel.get('uuid') || teaserModel.cid,
                    position: teaserModel.get('position'),
                    prevUuid: prevTeaser ? prevTeaser.get('uuid') || prevTeaser.cid : null,
                });

                const originalPosition = parseInt($item.data().originalPosition, 10);
                if (originalPosition.list === listUuid && originalPosition.position === teaserModel.get('position')) {
                    $item.removeClass('sda-teaser-updated');
                    teaserModel.set('modifiedPosition', false);
                }

                changeTeaserPlacement({
                    label: `${listUuid}/${cid}`,
                    value: teaserModel.get('position'),
                });

                $sendingList.sortable('refresh');
                $targetList.sortable('refresh');
            },
            stop(e, ui) {
                const $item = $(ui.item);

                that.$('.' + prevClass + ', .' + nextClass).removeClass(prevClass + ' ' + nextClass);

                $item.children('.sda-teaser-number').show();
            },
        });

        this.$('.sda-teaser-list').disableSelection({});
    },
    _saveTeaserListCollection($caller) {
        const result = $.Deferred();
        const opts = {
            type: 'PUT',
            url: '/api/facade_teaserPage/' + this.sectionId,
            beforeSend() {
                beforeMainLoader();
            },
            before() {
                $caller.addClass('disabled');
            },
            complete() {
                $caller.removeClass('disabled');
                completeMainLoader();
            },
            success(model, response, {mismatches = []} = {}) {
                if (Object.getOwnPropertyNames(response).length === 0 || property('success')(response) === false) {
                    result.reject('There was an error while saving');
                    console.error('PropertySectionView save error', response);
                    return;
                }
                if (mismatches.length) {
                    const container = this.el.querySelector('.modal-target');
                    const modal = (
                        <Modal onClose={() => ReactDOM.unmountComponentAtNode(container)} mismatches={mismatches} />
                    );
                    ReactDOM.render(modal, container);

                    conflictedTeaserPlacement({label: mismatches.length});
                }
                result.resolve(response);
            },
            error(model, response, error) {
                console.error('PropertySectionView teaser save error', error);
                result.reject(error);
            },
            context: this,
        };

        if (this.activeXhr && this.activeXhr.readyState > 0 && this.activeXhr.readyState < 4) {
            this.activeXhr.abort();
        }

        this.activeXhr = this.manualTeaserPlacementModel.save({}, opts);

        saveTeaserPlacement({
            label: this.manualTeaserPlacementModel.get('uuid'),
        });

        return result;
    },
    _saveBtnHandler(e) {
        const that = this;
        const $caller = $(e.target);

        const deferred = that._saveTeaserListCollection($caller, 'save');
        deferred
            .done(function() {
                messageHandler('success', 'Placement updated');
                that.render();
                that.renderManualTeaserPlacement();
            })
            .fail(function(msg) {
                console.error('PropertySectionView teaser list save error', msg);
                messageHandler('error', msg);
            });
    },

    _selectTeaser(e) {
        const $caller = $(e.target);
        const $teaser = $caller.closest('.sda-teaser-draggable');
        const selectedClass = 'sda-teaser-selected';
        const $currentlySelected = $('.' + selectedClass);

        // If mousedown occurred on edit icon ignore.
        if ($caller.closest('.sda-teaser-edit').length) {
            return false;
        }

        $currentlySelected.removeClass(selectedClass);

        if (!$teaser.is($currentlySelected)) {
            $teaser.addClass(selectedClass);
        }
        return undefined;
    },

    _registerHandlebarsHelper() {
        Handlebars.registerHelper('normalizeTitle', function(title) {
            return title.toLowerCase().replace(/[\W\s]+/g, '');
        });

        // in case uuid starts with a number
        Handlebars.registerHelper('normalizeId', function(id) {
            return `id-${id}`;
        });

        Handlebars.registerHelper('showValidTeaserLists', function(arr) {
            const prefix = 'id-';
            let listString = '';

            for (let i = arr.length - 1; i >= 0; i--) {
                listString += prefix + arr[i] + ' ';
            }

            return listString;
        });

        Handlebars.registerHelper('numberTeaser', function(i) {
            return i + 1;
        });

        Handlebars.registerHelper('styleSplitter', function(count) {
            return count * 68 + 40 + 'px';
        });

        Handlebars.registerHelper('teaserBelowFold', function(index, visibleCount) {
            return parseInt(index, 10) + 1 > parseInt(visibleCount, 10);
        });

        Handlebars.registerHelper('getStatus', function(status) {
            if (status === 'draft') {
                return '#069aff';
            } else if (status === 'published') {
                return '#00dc34';
            } else if (status === 'expired') {
                return '#ffaa00';
            }
        });
    },
});
